/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ConceptTerms from './concept-terms';
import ConceptTermsDetail from './concept-terms-detail';
import ConceptTermsUpdate from './concept-terms-update';
import ConceptTermsDeleteDialog from './concept-terms-delete-dialog';

const ConceptTermsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ConceptTerms />} />
    <Route path="new" element={<ConceptTermsUpdate />} />
    <Route path=":id">
      <Route index element={<ConceptTermsDetail />} />
      <Route path="edit" element={<ConceptTermsUpdate />} />
      <Route path="delete" element={<ConceptTermsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ConceptTermsRoutes;
